import { AccountRequest } from "./account.request";
import { BussinessRequest } from "./bussiness.request";

export class RegisterRequest {
  constructor(data = {}) {
    this.account = new AccountRequest(data.account);
    this.business = new BussinessRequest(data.business);
  }
}
